import { Box, Drawer, DrawerProps } from '@mui/material';
import { FC } from 'react';

type CommonDrawerProps = DrawerProps & {
  anchor: 'left' | 'right' | 'top' | 'bottom';
  open: boolean;
  onClose?: () => void;
  drawerWidth?: string;
  children: React.ReactNode;
};

const CommonDrawer: FC<CommonDrawerProps> = (props) => {
  const {
    anchor,
    open,
    onClose,
    children,
    drawerWidth = '30vw',
    id = 'commonDrawer',
    PaperProps,
    ...rest
  } = props;
  return (
    <Drawer
      anchor={anchor}
      open={open}
      onClose={onClose ?? (() => {})}
      PaperProps={{
        ...PaperProps,
        sx: {
          width: {
            xs: '100%',
            sm: '100%',
            md: '100%',
            lg: drawerWidth,
            xl: drawerWidth,
          },
          maxWidth: {
            xs: 'none',
            sm: 'none',
            md: 'none',
            lg: 'none',
            xl: 'none',
          },
          borderRadius: {
            xs: '0 !important',
            sm: '0 !important',
            md: '0 !important',
            lg: 'inherit',
            xl: 'inherit',
          },
          ...PaperProps?.sx,
        },
      }}
      {...rest}
    >
      <Box 
        id={id + 'Content'} 
        data-testid={id + '-content'}
        sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}
      >
        {children}
      </Box>
    </Drawer>
  );
};

export default CommonDrawer;
